module.exports = __webpack_public_path__ + "static/media/story_05.da16f72d.jpg";